import { StatusCheckIcon, ProjectManagerIcon, BudgetIcon, DetailIcon, CalendarIcon, ProjectNameIcon } from 'assets';
import { taskPriorityEnum } from 'shared/utils/Enum';
const tableHeading = [
    {
        Icon: ProjectNameIcon,
        heading: 'Project Name'
    },
    {
        Icon: DetailIcon,
        heading: 'Active Milestone'
    },
    {
        Icon: CalendarIcon,
        heading: 'Project Date'
    },
    {
        Icon: ProjectManagerIcon,
        heading: 'Project Manager'
    },
    {
        Icon: BudgetIcon,
        heading: 'Budget'
    },
    {
        Icon: StatusCheckIcon,
        heading: 'Status'
    }
];
const taskPriority = [
    {
        label:"Low",
        value:taskPriorityEnum.LOW
    },
    {
        label:"Medium",
        value:taskPriorityEnum.MIDDLE
    },
    {
        label:"High",
        value:taskPriorityEnum.HIGH
    }
]
const tableData = [
    {
        taskName: 'Develop Design',
        taskDesc: 'Design Must be Match as client requirements!',
        taskAssigned: 'Hamza',
        date: '12 Nov,2023',
        status: 'Pending',
        comments:'Something you want write here about task',
        checked:true,
        priority:'High'
    },
    {
        taskName: 'Develop Design',
        taskDesc: 'Design Must be Match as client requirements!',
        taskAssigned: 'Hamza',
        date: '12 Nov,2023',
        status: 'Complete',
        comments:'Something you want write here about task',
        live:'Amazon',
        priority:'Low'
    },
    {
        taskName: 'Develop Design',
        taskDesc: 'Design Must be Match as client requirements!',
        taskAssigned: 'Hamza',
        date: '12 Nov,2023',
        status: 'Inprocess',
        comments:'Something you want write here about task',
        checked:true,
        
    },
    {
        taskName: 'Develop Design',
        taskDesc: 'Design Must be Match as client requirements!',
        taskAssigned: 'Hamza',
        date: '12 Nov,2023',
        status: 'Stucked',
        live:'',
        priority:'Urgent'
    }
];
const options = [
    {
        title: 'SDLC Phase 1'
    },
    {
        title: 'SDLC Phase 2'
    },
    {
        title: 'SDLC Phase 3'
    }
];
const optionsConfigure = [
    {
        title: 'Configure'
    },
    {
        title: 'Rename'
    },
    {
        title: 'Remove'
    }
];

export { tableHeading, tableData, options, optionsConfigure,taskPriority };
